import { h } from 'vue'
import Azure from '@/assets/icons/azure.vue'
import BarChart from '@/assets/icons/bar-chart.vue'
import DoubleArrowDown from '@/assets/icons/double-arrow-down.vue'
import DoubleArrowUp from '@/assets/icons/double-arrow-up.vue'
import FolderConfig from '@/assets/icons/folder-config.vue'
import GitHub from '@/assets/icons/github.vue'
import Google from '@/assets/icons/google.vue'
import Microsoft from '@/assets/icons/microsoft.vue'
import NumberChart from '@/assets/icons/number-chart.vue'
import Saml from '@/assets/icons/saml.vue'
import Ssh from '@/assets/icons/ssh.vue'
import DateFnsAdapter from '@date-io/date-fns'
import { Icon } from '@iconify/vue'
import enGB from 'date-fns/locale/en-GB'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'

const defaultPrefix = 'material-symbols:'

const normalizeIcon = (icon) => {
  // if it starts with fa fa- return fa:
  if (icon.startsWith('fa fa-')) {
    return 'fa:' + icon.slice(6)
  }
  // if it start with fab fa- return fa:
  if (icon.startsWith('fab fa-')) {
    return 'fa:' + icon.slice(7)
  }
  // if it start with $, mdi-
  if (icon.startsWith('$') || icon.startsWith('mdi-') || icon.startsWith('fa-')) {
    return icon
  }
  if (icon.includes(':')) {
    return icon
  }
  return defaultPrefix + icon.replaceAll('_', '-')
}

const iconify = {
  component: (props) => {
    const { icon, tag, class: className, ...rest } = props
    const stringIcon = normalizeIcon(icon)

    return h(tag, { class: className, ...rest }, [
      h(Icon, {
        key: stringIcon,
        inline: true,
        icon: stringIcon,
      }),
    ])
  },
}

const FIELDS_VARIANT = 'underlined'

/** @type {import('vuetify').VuetifyOptions} */
export const options = {
  date: {
    adapter: DateFnsAdapter,
    locale: {
      en: enGB,
      fr,
      es,
    },
  },
  defaults: {
    VTextField: {
      variant: FIELDS_VARIANT,
    },
    VTextarea: {
      variant: FIELDS_VARIANT,
    },
    VSelect: {
      variant: FIELDS_VARIANT,
    },
    VCombobox: {
      variant: FIELDS_VARIANT,
    },
    VAutocomplete: {
      variant: FIELDS_VARIANT,
    },
    VSlider: {
      trackSize: '2px',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      dark: {
        dark: true,
        colors: {
          background: '#fafafa',
          primary: '#253449',
          secondary: '#1c9797',
          accent: '#f08b02',
          info: '#1c9797',
          success: '#51af45',
          error: '#e6213c',
          warning: '#fbbc0f',
          darkgrey: '#838589',
        },
        variables: {
          'disabled-opacity': 0.6,
        },
      },
      light: {
        dark: false,
        colors: {
          background: '#fafafa',
          primary: '#253449',
          secondary: '#1c9797',
          accent: '#f08b02',
          info: '#1c9797',
          success: '#51af45',
          error: '#e6213c',
          warning: '#fbbc0f',
          darkgrey: '#838589',
        },
        variables: {
          'disabled-opacity': 0.6,
        },
      },
    },
  },
  icons: {
    defaultSet: 'iconify',
    sets: {
      iconify,
    },
    aliases: {
      // general icons
      barChart: BarChart,
      doubleArrowDown: DoubleArrowDown,
      doubleArrowUp: DoubleArrowUp,
      folderConfig: FolderConfig,
      numberChart: NumberChart,
      ssh: Ssh,
      // SSO provider icons
      azuread: Azure,
      github: GitHub,
      google: Google,
      microsoft: Microsoft,
      saml: Saml,
      clear: 'mdi:close',
    },
  },
}

export default createVuetify(options)
